export default "__VITE_ASSET__841f54aa__"